import React, { useEffect, useRef } from 'react';
import emptyImage from '../../../assets/images/emptylist.png';

function UserWalletTransactionsScrollable({ userWalletTransactions, getUserWalletHeight, userWalletTransactionsLoading, handleLoadData }) {

    const getTransactionAmountColorClassname = (transactionReference, amount) => {
        if (transactionReference === 0) { // visit approval
            if (amount < 0) {
                return 'user-wallet-transaction-negative-value';
            }
        }
        else if (transactionReference === 1) { // visit done (by app)
            return 'waiting-color';
        }
        else if (transactionReference === 2) { // payment done
            if (amount < 0) {
                return 'user-wallet-transaction-negative-value';
            } else {
                return 'third-color';
            }
        }
        else if (transactionReference === 3) { // transaction done
            if (amount < 0) {
                return 'user-wallet-transaction-negative-value';
            } else {
                return 'third-color';
            }
        }
        else if (transactionReference === 4) { // invite reward available
            return 'primary-color';
        }
        else if (transactionReference === 5) { // invite reward available
            return 'primary-color';
        }
        else if (transactionReference === 6) { // invite reward available
            return 'gray-color';
        }
    }

    const handleScrolling = (event) => {
        const {scrollTop, clientHeight, scrollHeight} = event.target;
        if (scrollTop + clientHeight >= scrollHeight -10) {
            handleLoadData()
        }
    }

    return (
        <div className="card">
            <div className="card-body scroll-container user-wallet-container" onScroll={handleScrolling}>
                <ul className="email-app-sidebar user-personal-data user-wallet-transaction-list" style={{ height: `${getUserWalletHeight()}px` }}>
                    {userWalletTransactions?.map(transaction =>
                        <li key={transaction.id}>
                            {transaction.redirectUrl !== null ?
                                <a target="_blank" rel="noopener noreferrer" href={transaction.redirectUrl}>
                                    <h3 className={`${transaction.transaction.includes("Visita rejeitada") ? "error-color" : transaction.transaction.includes("Visita aprovada") && "main-color" } user-wallet-transaction-title`}>{transaction.transaction}</h3>
                                </a>
                                :
                                <h3 className="user-wallet-transaction-title">{transaction.transaction}</h3>
                            }
                            <div className="flex space-between">
                                <div style={{ maxWidth: '75%' }}>
                                    <div>
                                        {transaction.description}
                                        {transaction.pointOfSaleName && <p>Ponto de Venda: <b>{transaction.pointOfSaleName}</b></p>}
                                    </div>
                                    <p className="user-wallet-transaction-date">{transaction.registerDate}</p>
                                </div>
                                {transaction.amount === 0 ? '-' :
                                    <b><p className={`user-wallet-transaction-value ${getTransactionAmountColorClassname(transaction.referenceType, transaction.amount)}`}>{transaction.amountFormated}</p></b>
                                }
                            </div>
                        </li>)}
                    {!userWalletTransactionsLoading && userWalletTransactions?.length <= 0 && (
                        <div className="align-center">
                            <div className="empty-list-txt">Nenhuma transação efetuada</div>
                            <img className="empty-list-img" src={emptyImage} alt="empty list" />
                        </div>
                    )}
                </ul>
            </div>
        </div>
    );
}

export default UserWalletTransactionsScrollable;